export default __webpack_public_path__ + "static/bg_image_other-f778f50c91a2e01ad45ab9791d7397b2.jpg";